(function () {
  // This script is included by both the wl-business_case-nav section and
  // every wl-business_case section, so it may appear on the page multiple
  // times — guard so it only ever runs once.
  if (window.__wlBusinessCaseInit) return;
  window.__wlBusinessCaseInit = true;

  // Theme blocks ("wl-business-case-image" / "wl-business-case-sub-product")
  // each render inside an auto-injected `<div class="shopify-block">`
  // wrapper (Shopify adds one around every {% render block %} call). CSS
  // alone (`display: contents`, see section_wl-business_case.css) fixes
  // the *visual* layout, but Splide finds its slides by walking the actual
  // DOM tree — it doesn't know about `display: contents` — so a
  // `.splide__list` whose direct children are all `.shopify-block` wrappers
  // reports 0 slides even though they render at the right size. Unwrapping
  // here (replacing each wrapper with its own children, right before the
  // Splide it belongs to mounts) makes the <li> a genuine direct child.
  function unwrapShopifyBlocks(container) {
    if (!container) return;
    container.querySelectorAll(':scope > .shopify-block').forEach(function (wrapper) {
      while (wrapper.firstChild) {
        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
    });
  }
  window.__wlBusinessCaseUnwrapShopifyBlocks = unwrapShopifyBlocks;

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Splide === 'undefined') return;

    // Cards use a fixed CSS width (see section_wl-business_case.css) so the
    // next card always peeks at the edge, matching the reference design —
    // autoWidth reads that width instead of dividing the track into perPage
    // percentage-based columns.
    document.querySelectorAll('.wl-business_case__images.splide').forEach(function (el) {
      var caseEl = el.closest('.wl-business_case');
      var current = caseEl ? caseEl.querySelector('.wl-business_case__counter__current') : null;
      var total = caseEl ? caseEl.querySelector('.wl-business_case__counter__total') : null;
      var prevBtn = caseEl ? caseEl.querySelector('.wl-business_case__arrow--prev') : null;
      var nextBtn = caseEl ? caseEl.querySelector('.wl-business_case__arrow--next') : null;

      unwrapShopifyBlocks(el.querySelector('.splide__list'));

      // Each "wl-business-case-image" block renders its own modal <div>
      // right after its <li>, so on mount the track still contains those
      // hidden modals as extra children — pull them out before Splide
      // measures the track, or its slide count/autoWidth math (which reads
      // all track children, not just .splide__slide ones) gets thrown off.
      if (caseEl) {
        caseEl.querySelectorAll('[id^="CaseModal-"]').forEach(function (modal) {
          caseEl.appendChild(modal);
        });
      }

      var splide = new Splide(el, {
        type: 'loop',
        autoWidth: true,
        focus: 0,
        start: 0,
        gap: '2px',
        arrows: false,
        pagination: false,
        drag: true,
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });

      // Sideways scrolling on a PC (touchpad two-finger swipe, Shift+wheel,
      // tilt wheel) arrives as horizontal wheel events, which Splide ignores
      // — and with the arrows hidden (see .wl-business_case__ctrl in
      // section_wl-business_case.css) that left mouse drag as the only way
      // to reach the cards past the right edge. Splide's own `wheel` option
      // isn't used because it also captures plain vertical wheel, which on
      // a loop carousel (no end to release at) would trap page scrolling
      // whenever the cursor is over the cards. So only the horizontal case
      // is handled here, one card per gesture: a single swipe keeps firing
      // inertia events for a second or so, and the idle timer treats that
      // whole burst as one gesture.
      var wheelHandled = false;
      var wheelIdleTimer = null;
      el.addEventListener(
        'wheel',
        function (e) {
          // Chrome already reports Shift+wheel as deltaX; browsers that
          // don't leave it in deltaY with shiftKey set.
          var shiftedVertical = e.shiftKey && !e.deltaX;
          var horizontal = shiftedVertical ? e.deltaY : e.deltaX;
          var vertical = shiftedVertical ? 0 : e.deltaY;
          if (Math.abs(horizontal) <= Math.abs(vertical)) return;

          // Also keeps the swipe from triggering the browser's own
          // back/forward history gesture.
          e.preventDefault();
          clearTimeout(wheelIdleTimer);
          wheelIdleTimer = setTimeout(function () {
            wheelHandled = false;
          }, 150);

          // A touchpad gesture ramps up from 1-2px deltas — wait for a
          // deliberate one. (deltaMode 0 = pixels; line/page deltas from a
          // notched wheel are always deliberate.)
          if (wheelHandled || (e.deltaMode === 0 && Math.abs(horizontal) < 4)) return;
          wheelHandled = true;
          splide.go(horizontal > 0 ? '>' : '<');
        },
        { passive: false }
      );

      // splide.length/index are only valid once the Slides component is
      // built, i.e. after mount() — reading them earlier throws.
      var updateCurrent = function () {
        if (total) total.textContent = splide.length;
        if (current) current.textContent = splide.index + 1;
      };
      splide.on('mounted moved', updateCurrent);

      splide.mount();
      // With autoWidth in loop mode, Splide sometimes lands on a middle
      // slide as "active" on first paint instead of the first real slide —
      // force it back to 0 as a safeguard.
      splide.go(0);
    });

    document.querySelectorAll('.wl-business_case__subProducts__list.splide').forEach(function (el) {
      unwrapShopifyBlocks(el.querySelector('.splide__list'));
      new Splide(el, {
        type: 'slide',
        autoWidth: true,
        gap: '1px',
        arrows: false,
        pagination: false,
        drag: true,
      }).mount();
    });

    // Case 3's expanded product grid (.wl-business_case__subProducts__list--grid)
    // has no Splide/JS carousel of its own. Its rendered children are a flat,
    // row-major list (1,2,3 / 4,5,6 / ...) — grouping them into 6-item
    // ".page" wrappers here (rather than in Liquid, which would need its own
    // counter threaded through this section's existing image/sub-product
    // marker-tracking loop) lets a single set of DOM nodes serve both
    // layouts: `display: contents` on desktop/tablet (inert, items still
    // participate directly in the 5/3-column grid) and a real 3x2 grid per
    // page on mobile (see section_wl-business_case.css) — plain
    // `grid-auto-flow: column` on the flat list would reorder items into
    // column-major (1,4 / 2,5 / 3,6) instead of matching the design's
    // reading order.
    document.querySelectorAll('.wl-business_case__subProducts__list--grid').forEach(function (grid) {
      var perPage = 6;
      var children = Array.prototype.slice.call(grid.children);
      if (!children.length) return;

      var pages = [];
      for (var i = 0; i < children.length; i += perPage) {
        var page = document.createElement('div');
        page.className = 'wl-business_case__subProducts__page';
        children.slice(i, i + perPage).forEach(function (child) {
          page.appendChild(child);
        });
        grid.appendChild(page);
        pages.push(page);
      }

      var dotsEl = grid.nextElementSibling;
      if (!dotsEl || !dotsEl.classList.contains('js-wl-business_case__subProducts__dots')) return;
      if (pages.length <= 1) return;

      var dots = [];
      pages.forEach(function (page, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wl-business_case__subProducts__dot';
        dot.setAttribute('aria-label', index + 1);
        dot.addEventListener('click', function () {
          page.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsEl.appendChild(dot);
        dots.push(dot);
      });

      var setActiveDot = function () {
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        var ratio = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
        var active = Math.round(ratio * (pages.length - 1));
        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === active);
        });
      };

      setActiveDot();
      var ticking = false;
      grid.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            setActiveDot();
            ticking = false;
          });
        },
        { passive: true }
      );
    });

    var navLinks = document.querySelectorAll('.wl-business_case-nav__link');
    var cases = document.querySelectorAll('.wl-business_case');
    if (!cases.length) return;

    if ('IntersectionObserver' in window && navLinks.length) {
      var setActive = function (id) {
        navLinks.forEach(function (link) {
          link.classList.toggle('is-active', link.dataset.target === id);
        });
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
      );

      cases.forEach(function (caseEl) {
        observer.observe(caseEl);
      });

      setActive(cases[0].id);
    }

    // Pinned "Case NN" label (mobile "Contents" layout — see
    // .wl-business_case__numberBadge in section_wl-business_case.css,
    // display:none above the mobile breakpoint): each case's own
    // .wl-business_case__number scrolls out of view as soon as the visitor
    // scrolls past that case's header, well before they've finished
    // scrolling through its images/sub-products — this floating badge
    // takes over at that exact point (its own fixed position:sticky
    // equivalent is unavailable, see the <main> overflow:hidden comment
    // below) so the current case's number stays on screen for as long as
    // any part of that case is still in view.
    var numberBadge = document.createElement('div');
    numberBadge.className = 'wl-business_case__numberBadge';
    numberBadge.setAttribute('aria-hidden', 'true');
    document.body.appendChild(numberBadge);

    var updateNumberBadge = function () {
      // getBoundingClientRect (not a cached constant) because this fixed
      // element's own `top` is a calc() off --headerHeight, which can
      // change between breakpoints/on resize.
      var pinTop = numberBadge.getBoundingClientRect().top;
      var current = null;

      // Forward order so that at a case/case boundary (both technically
      // matching for a single frame) the later — i.e. incoming — case
      // wins, matching what the visitor is scrolling toward.
      for (var i = 0; i < cases.length; i++) {
        var caseEl = cases[i];
        var numberEl = caseEl.querySelector('.wl-business_case__number');
        if (!numberEl) continue;

        var caseBottom = caseEl.getBoundingClientRect().bottom;
        var numberTop = numberEl.getBoundingClientRect().top;

        // Only take over once the case's own inline number has actually
        // scrolled above the pin line, and only until the case itself has
        // scrolled fully past it — otherwise the badge would double up
        // with the still-visible inline number, or linger into the next
        // case before its own number appears.
        if (numberTop <= pinTop && caseBottom > pinTop) {
          current = caseEl;
        }
      }

      if (current) {
        var numberEl = current.querySelector('.wl-business_case__number');
        numberBadge.textContent = numberEl.textContent;
        numberBadge.classList.add('is-visible');
      } else {
        numberBadge.classList.remove('is-visible');
      }
    };

    // Fixed side nav: position:sticky can't be used because the theme's
    // global <main> wrapper sets overflow:hidden, which silently breaks it.
    // Instead show/hide the fixed nav based on scroll position relative to
    // the hero banner and the catalog section — not the nav's own (now
    // vertically centered) position, and not the case sections' own
    // height, or the nav ends up showing while still overlapping the hero
    // (visible too early) or lingering into the catalog area (visible too
    // late).
    var nav = document.querySelector('.wl-business_case-nav');
    var heroSection = document.querySelector('.wl-business_kv');
    // The catalog section immediately follows the last case section and
    // opens with its own top border (see .wl-business_case__frame in
    // section_wl-business_catalog.css) — hide the nav right as that border
    // is about to reach the nav's own box, rather than waiting for the
    // (taller) last case section to fully scroll past.
    var catalogSection = document.querySelector('.wl-business_catalog');
    var ticking = false;

    var updateNavVisibility = function () {
      if (!nav) return;

      if (window.innerWidth < 1000) {
        nav.classList.remove('is-visible');
        return;
      }

      // Measured against the nav's own box (not a fixed header-height
      // offset) so it never visually overlaps the hero or the catalog
      // border regardless of where the nav itself sits on screen (it's
      // vertically centered — top:50%/translateY(-50%) — so a near-top
      // threshold like "header height" is nowhere near its actual
      // position). getBoundingClientRect() still reports the nav's real
      // position even while hidden (opacity/visibility, not display:none).
      var navRect = nav.getBoundingClientRect();
      var heroBottom = heroSection ? heroSection.getBoundingClientRect().bottom : 0;
      var catalogTop = catalogSection ? catalogSection.getBoundingClientRect().top : Infinity;

      // Show only once the hero has scrolled past the nav's own top edge;
      // hide as soon as the catalog section's top border is about to
      // reach the nav's own bottom edge.
      var pastHero = heroBottom <= navRect.top;
      var beforeCatalog = catalogTop > navRect.bottom;

      nav.classList.toggle('is-visible', pastHero && beforeCatalog);
    };

    var onScrollOrResize = function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          ticking = false;
          updateNavVisibility();
          updateNumberBadge();
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    updateNavVisibility();
    updateNumberBadge();
  });
})();
